module.exports = __webpack_public_path__ + "static/lokal-37baa4d5edc42e9afc3274629f3e51ba.png";